import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { createProjectMembersActions } from './project-members.actions'
import { projectMembersInitialState } from './project-members.slice'
import { createProjectsSyncActions } from './projects.actions'
import { projectsInitialState } from './projects.slice'
import type { ProjectsStore } from './projects.type'

export const useProjectsStore = create<ProjectsStore>()(
  devtools(
    subscribeWithSelector(
      immer((set) => ({
        ...projectsInitialState,
        ...projectMembersInitialState,
        ...createProjectsSyncActions(set),
        ...createProjectMembersActions(set),
      }))
    ),
    { name: StoreDevtoolsName.Projects, enabled: process.env.NODE_ENV === 'development' }
  )
)
